import { useMutation } from '@apollo/client'
import { FormModal } from '@chaine/keychaine'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'

import { Toast } from '../../../_shared/components/toast'
import { validations } from '../../../_utils/validations/validations'
import { AppModalProps } from '../components/apps-data'
import { ENABLE_HIGHWAY_APP } from '../data/mutations'

/**
 * Save's Highway app's client id and client secret for enable this app
 * @param props.app the app
 * @param props.isOpen sets the modal to open or closed
 * @param props.onClose closes the modal
 */
const HighwayModal = React.memo((props: AppModalProps) => {
  const { isOpen, onClose, appType, refetchApps } = props

  const { showToast } = Toast()

  const [enableHighwayApp, { loading }] = useMutation<{ enableHighwayApp: { id: string } }, { accessToken: string }>(
    ENABLE_HIGHWAY_APP,
    {
      onCompleted: () => {
        showToast({
          status: 'success',
          title: `Highway app has been enabled`
        })
        refetchApps()
        onClose()
      },

      onError: (err) => {
        if (err.message === 'Unauthorized') {
          showToast({
            status: 'error',
            title: `The Highway access token is invalid.`
          })
        } else {
          showToast({
            status: 'error',
            title: `Something went wrong. Please contact support@chaineapp.com. Error: ${err.message}`
          })
        }
      }
    }
  )

  type FieldValues = { accessToken: string }

  const handleSaveDetails: SubmitHandler<FieldValues> = (event) => {
    enableHighwayApp({
      variables: { accessToken: event.accessToken }
    })
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Enable ${appType} for Chaine`}
      subtitle={`Enabling this integration requires a Highway account. You will need to add your Highway access token. This can be obtained by either having your Chaine Implementation Representative obtain it from Highway, or you can email Highway support for an access token to be used for Chaine.`}
      formSubmitHandler={handleSaveDetails}
      buttonText={'Save access token'}
      initialValues={{}}
      validations={validations}
      isLoading={loading}
      modalItems={[
        {
          labelText: 'Highway Access Token',
          name: 'accessToken',
          placeHolder: 'Enter your Highway access token',
          type: 'input'
        }
      ]}
    />
  )
})

HighwayModal.displayName = 'HighwayModal'

export { HighwayModal }
